import {
  DateRange,
  FilterValue,
  isDateRange,
  isStringArray,
} from "@inductiveautomation/ws-components";
import { isBefore, set } from "date-fns";

export const filterPresent = (
  filter: FilterValue | undefined
): filter is string[] => isStringArray(filter) && filter.length > 0;

export const matchesStringArrayFilter = (
  filter: FilterValue | undefined,
  value: string
) => {
  if (!filterPresent(filter)) return true;

  return filter.includes(value);
};

const dateFilterPresent = (
  filter: FilterValue | undefined
): filter is DateRange => {
  return (
    (filter &&
      typeof filter !== "boolean" &&
      !Array.isArray(filter) &&
      isDateRange(filter)) ??
    false
  );
};

export const matchesDateRangeFilter = (
  range: FilterValue | undefined,
  value: Date | undefined
) => {
  if (!dateFilterPresent(range) || !range.from) return true;

  if (!value) {
    // If the filter is present, but there is no value, the item is excluded based on the filter.
    return false;
  } else if (!range.to) {
    return range.from === value;
  } else {
    const toValue = set(range.to, {
      hours: 23,
      minutes: 59,
      seconds: 59,
      milliseconds: 999,
    });
    return isBefore(range.from, value) && isBefore(value, toValue);
  }
};

export const addDashToKey = (key: string) => {
  return `${key.slice(0, 4)}-${key.slice(4)}`;
};
